import { useState, useEffect } from 'react'

export function useCountdown(initialMinutes: number, initialSeconds: number) {
  const [timeLeft, setTimeLeft] = useState(initialMinutes * 60 + initialSeconds)

  useEffect(() => {
    const interval = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev <= 0) {
          // Reset to a random time between 10 and 15 minutes to maintain urgency if they stay long
          return Math.floor(Math.random() * 5 * 60) + 10 * 60
        }
        return prev - 1
      })
    }, 1000)
    return () => clearInterval(interval)
  }, [])

  const minutes = Math.floor(timeLeft / 60)
  const seconds = timeLeft % 60

  return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`
}
